<template>

  <div class="alert alert-primary" role="alert"
    v-for="n in notifications"
    v-if="!editing && !isAdmin && notifications.length && notifications[0]?.content?.length">
    {{ n.content }}
  </div>

  <div class="alert alert-primary" role="alert" v-for="n in notifications" v-if="!editing && isAdmin">
    <div class="row">
      <div class="col-10">
        {{ n.content }}
      </div>
      <div class="col" v-if="isAdmin">
        <button type="button" class="btn btn-secondary" @click="editing=n">✎</button>
      </div>
    </div>
  </div>

  <div class="alert alert-danger" role="alert" v-if="!notifications.length && isDone && isAdmin && !editing">
    <button type="button" class="btn btn-secondary" @click="editing = { isNew: true }">✎</button>
  </div>

  <div class="alert alert-info" role="alert" v-if="!!editing">
    <div class="row">
      <div class="col-10">
        <input type="text" class="form-control" v-model="editing.content">
      </div>
      <div class="col">
        <button type="button" class="btn btn-success" @click="saveAsync">Shrani</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { listEntitiesAsync, saveEntityAsync } from "../api"
import {
  useAuth,
  authState,
  isAuthenticated,
  user,
  role,
  isAdmin,
  showMessageToWorker,
  currentWorkerId,
} from "../composition-api/useAuth"

defineOptions({ name: "Notifications" })

const notifications = ref([])
const isDone = ref(false)
const editing = ref(null)
const { fetchAuthAsync } = useAuth()

onMounted(async () => {
  notifications.value = await listEntitiesAsync(fetchAuthAsync, "Notifications")
  isDone.value = true
})

const saveAsync = async () => {
  const result = await saveEntityAsync(fetchAuthAsync, "Notification", editing.value, editing.value.isNew)
  if (!result) return
  editing.value = null
  notifications.value = await listEntitiesAsync(fetchAuthAsync, "Notifications")
}
</script>
